export default __webpack_public_path__ + "static/pizza-block-1-c8dd5babf8a4cf72bd9a2e612b6a31e9.jpg";